'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

const initialState: boolean = false;

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError: (_state, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setError } = errorSlice.actions;
export default errorSlice.reducer;
export const errorSelector = (state: RootState) => state.error;
